import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import propertyReducer from "./slices/propertySlice";
import unitReducer from "./slices/unitSlice";
import bookingReducer from "./slices/bookingSlice";
import statisticsReducer from "./slices/statisticsSlice";
import appMessageReducer from "./slices/appMessageSlice";
import cleanerReducer from "./slices/cleanerSlice";
import cleaningTaskReducer from "./slices/cleaningTaskSlice";
import billingReducer from "./slices/billingSlice";
import expenseReducer from "./slices/expenseSlice";
import recurringExpenseReducer from "./slices/recurringExpenseSlice";
import settingsReducer from "./slices/settingsSlice";
import guestReducer from "./slices/guestSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    properties: propertyReducer,
    units: unitReducer,
    bookings: bookingReducer,
    statistics: statisticsReducer,
    appMessage: appMessageReducer,
    cleaners: cleanerReducer,
    cleaningTasks: cleaningTaskReducer,
    billing: billingReducer,
    expenses: expenseReducer,
    recurringExpenses: recurringExpenseReducer,
    settings: settingsReducer,
    guests: guestReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
